// extracted by mini-css-extract-plugin
export default {"popularJobsSec":"PopularJobs_popularJobsSec__oSDFR","jobBgWrapper":"PopularJobs_jobBgWrapper__2TPbh"};